var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.143,
    height: 25.082,
    viewBox: "0 0 33.143 25.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-0.001 -1.646)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 24.09,
    height: 1.984,
    transform: "translate(4.534 24.743)",
    fill: "#92d4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M33.073,11.833c-.383-2.041-2-3.571-4.818-4.577l-.666,1.871c2.1.751,3.288,1.771,3.543,3.061.5,2.65-2.848,6.207-4.166,7.34l-.51.411H23.778c1.559-2.225,4.86-7.61,3.118-11.166-.978-1.984-3.259-3-6.8-3V7.752c2.721,0,4.407.638,5.016,1.885,1.332,2.735-2.14,8.162-3.6,10.033l-.241.269h-3.7V5.116a2.126,2.126,0,1,0-1.984,0V19.967H11.86l-.213-.269c-1.445-1.856-4.931-7.3-3.6-10.033.609-1.247,2.3-1.885,5.016-1.885V5.8c-3.543,0-5.824,1.006-6.8,3C4.52,12.371,7.822,17.756,9.38,19.967H6.617l-.425-.411c-1.332-1.148-4.662-4.7-4.166-7.34.241-1.29,1.431-2.324,3.543-3.061L4.9,7.284C2.083,8.262.467,9.807.084,11.833c-.751,3.982,3.812,8.3,4.676,9.083v1.02h24.09v-1.46c1.445-1.4,4.875-5.158,4.209-8.644Z",
    transform: "translate(0 0.526)",
    fill: "#92d4d0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkat);
export default __webpack_public_path__ + "static/media/SKAT.01a491811a96a07dcb74c0b8ad18b628.svg";
export { ForwardRef as ReactComponent };